'use strict';
var i, len, makeTag, ref, tagName;

makeTag = function(name, attr, content) {
  var html, key, ref, tail, val;
  if (attr == null) {
    attr = {};
  }
  if (content == null) {
    content = '';
  }
  if (typeof attr === 'string') {
    ref = [{}, attr], attr = ref[0], content = ref[1];
  }
  html = "<" + name;
  tail = "</" + name + ">";
  for (key in attr) {
    val = attr[key];
    key = _.escape(key);
    val = _.escape(String(val));
    html += ' ' + key + '="' + val + '"';
  }
  return html + '>' + content + tail;
};

ref = ['a'];
for (i = 0, len = ref.length; i < len; i++) {
  tagName = ref[i];
  makeTag[tagName] = _.partial(makeTag, tagName);
}

module.exports = makeTag;

